import { Fragment } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { useTranslation } from "react-i18next";
import { updateSetting } from "actions/userSetiting";
import SelectBox from "components/elements/selectBox";
import { Languages } from "helper/constant";

function ModalSetting({ isOpen, onToggle, settings, onFormChange, updateSetting }) {
    const { t } = useTranslation();

    const handleSubmit = () => {
        if (settings?.thankYouTemplate === "" || !settings?.thankYouTemplate) {
            settings.thankYouTemplate = "Thank you for shopping with {shop_name}! Your order has been confirmed and will be delivered to you in the next few days. We hope you love your purchase! If you have any questions, feel free to reach out."
        }
        if (settings?.orderTransitTemplate === "" || !settings?.orderTransitTemplate) {
            settings.orderTransitTemplate = `Hi {buyer_name}!
Good news – your order is on its way! 🚚✨ Your package has been shipped and will be arriving soon. We’ll keep you updated with tracking information so you can follow its journey.

Thanks again for shopping with {shop_name}! We hope you enjoy your purchase when it arrives.`
        }
        if (settings?.feedbackTemplate === "" || !settings?.feedbackTemplate) {
            settings.feedbackTemplate = `Hi {buyer_name}!
We hope your order has arrived safely! If you're happy with your purchase and our service, we'd be so grateful if you could leave us a 5-star review. Your positive feedback means a lot to us and helps us grow!

Once you've had a chance to try it, feel free to share your experience – we’d love to hear what you think!

Thank you so much for supporting {shop_name}!`
        }
        updateSetting(settings);
    };

    // List of symbols with descriptions
    const symbols = [
        { symbol: '{buyer_name}', description: 'Customer Name' },
        { symbol: '{shop_name}', description: 'Shop Name' },
        { symbol: '{days_since_order}', description: 'Days Since Order' },
        { symbol: '{days_since_delivery}', description: 'Days Since Delivery' },
        { symbol: '{days_since_transit}', description: 'Days Since Transit' },
        { symbol: '{order_id}', description: 'Order ID' },
    ];

    // Function to insert symbol into textarea at the current cursor position
    const insertSymbol = (symbol, field) => {
        const textarea = document.getElementById(field);
        const cursorPos = textarea.selectionStart;
        const textBefore = textarea.value.substring(0, cursorPos);
        const textAfter = textarea.value.substring(cursorPos);
        const newText = textBefore + symbol + textAfter;
        textarea.value = newText;

        // Update settings with the new message
        onFormChange({ target: { name: field, value: newText } });
    };

    return (
        <Fragment>
            <Modal
                centered={true}
                size="xl"
                toggle={() => {
                    onToggle();
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Setting")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                onToggle();
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="row">
                        <div className="col-3 col-md-3">
                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                    <span className="required">{t("Auto Send Translate")}</span>
                                </label>
                                <div className="form-check form-check-solid form-switch form-check-custom fv-row">
                                    <input
                                        className="form-check-input w-45px h-30px"
                                        type="checkbox"
                                        checked={settings?.autoTranslate || false}
                                        name="autoTranslate"
                                        onChange={(e) => {
                                            onFormChange(e);
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor="manage_product"></label>
                                </div>
                            </div>
                        </div>
                        <div className="col-3 col-md-9">
                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                    <span className="required">{t("Language Translate")}</span>
                                </label>
                                <SelectBox
                                    options={Languages}
                                    placeholder="Select language"
                                    value={settings?.languageTranslate || ""}
                                    onChange={(data) => {
                                        onFormChange({ target: { name: "languageTranslate", value: data.value } });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 card shadow">
                            <div className="card-header text-white">
                                <h5 className="card-title mb-0">
                                    <i className="bi bi-gear-fill me-3 fs-2"></i>
                                    Message Template Settings
                                </h5>
                            </div>
                            <div className="card-body">
                                <div className="mb-4 row">
                                    <div className="col-md-8">
                                        <label className="form-label fw-semibold">
                                            Thank You Message Template
                                        </label>
                                        <textarea
                                            className="form-control message-template"
                                            id="thankYouTemplate"
                                            rows={8}
                                            placeholder="Enter your personalized thank you message..."
                                            value={settings?.thankYouTemplate || 'Thank you for shopping with {shop_name}! Your order has been confirmed and will be delivered to you in the next few days. We hope you love your purchase! If you have any questions, feel free to reach out.'}
                                            onChange={(e) => {
                                                onFormChange({ target: { name: "thankYouTemplate", value: e.target.value } });
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label fw-semibold">
                                            How many hours after purchase
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control message-template mb-2"
                                            id="orderTime"
                                            value={settings?.orderTime || ''}
                                            onChange={(e) => {
                                                onFormChange({ target: { name: "orderTime", value: e.target.value } });
                                            }}
                                            placeholder="Enter hours"
                                        />
                                        <label className="form-label fw-semibold">
                                            Status
                                        </label>
                                        <select
                                            className="form-control message-template"
                                            name="orderStatus"
                                            value={settings?.orderStatus || 'inactive'}
                                            onChange={(e) => {
                                                onFormChange({ target: { name: "orderStatus", value: e.target.value } });
                                            }}
                                        >
                                            <option value="inactive">Inactive</option>
                                            <option value="active">Active</option>
                                        </select>
                                        <label className="form-label fw-semibold mt-2">
                                            AI generative
                                        </label>
                                        <select
                                            className="form-control message-template"
                                            name="orderAIgen"
                                            value={settings?.orderAIgen || 'inactive'}
                                            onChange={(e) => {
                                                onFormChange({ target: { name: "orderAIgen", value: e.target.value } });
                                            }}
                                        >
                                            <option value="inactive">Inactive</option>
                                            <option value="active">Active</option>
                                        </select>
                                    </div>
                                    <div className="mt-3">
                                        <label className="form-label fw-semibold">
                                            Available Symbols
                                            <span className="text-muted fs-6"> (Click to insert)</span>
                                        </label>
                                        <div className="d-flex flex-wrap gap-1">
                                            {symbols.map((item, index) => (
                                                <div key={index} className="position-relative">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary border-primary  btn-sm symbol-btn border al-border-radius-8"
                                                        onClick={() => insertSymbol(item.symbol, 'thankYouTemplate')}  // Chỉnh sửa ở đây
                                                        title={item.description}
                                                        data-bs-toggle="tooltip"
                                                    >
                                                        {item.symbol}
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="mb-4 row">
                                    <div className="col-md-8">
                                        <label className="form-label fw-semibold">
                                            Order In Transit Template
                                        </label>
                                        <textarea
                                            className="form-control message-template"
                                            id="orderTransitTemplate"
                                            rows={8}
                                            placeholder="Enter your personalized thank you message..."
                                            value={settings?.orderTransitTemplate || `Hi {buyer_name}!
Good news – your order is on its way! 🚚✨ Your package has been shipped and will be arriving soon. We’ll keep you updated with tracking information so you can follow its journey.

Thanks again for shopping with {shop_name}! We hope you enjoy your purchase when it arrives.`}
                                            onChange={(e) => {
                                                onFormChange({ target: { name: "orderTransitTemplate", value: e.target.value } });
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label fw-semibold">
                                            How many hours after in transit
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control message-template mb-2"
                                            id="orderTransitTime"
                                            value={settings?.orderTransitTime || ''}
                                            onChange={(e) => {
                                                onFormChange({ target: { name: "orderTransitTime", value: e.target.value } });
                                            }}
                                            placeholder="Enter hours"
                                        />
                                        <label className="form-label fw-semibold">
                                            Status
                                        </label>
                                        <select
                                            className="form-control message-template"
                                            name="orderTransitStatus"
                                            value={settings?.orderTransitStatus || 'inactive'}
                                            onChange={(e) => {
                                                onFormChange({ target: { name: "orderTransitStatus", value: e.target.value } });
                                            }}
                                        >
                                            <option value="inactive">Inactive</option>
                                            <option value="active">Active</option>
                                        </select>
                                        <label className="form-label fw-semibold mt-2">
                                            AI generative
                                        </label>
                                        <select
                                            className="form-control message-template"
                                            name="orderTransitAIgen"
                                            value={settings?.orderTransitAIgen || 'inactive'}
                                            onChange={(e) => {
                                                onFormChange({ target: { name: "orderTransitAIgen", value: e.target.value } });
                                            }}
                                        >
                                            <option value="inactive">Inactive</option>
                                            <option value="active">Active</option>
                                        </select>
                                    </div>
                                    <div className="mt-3">
                                        <label className="form-label fw-semibold">
                                            Available Symbols
                                            <span className="text-muted fs-6"> (Click to insert)</span>
                                        </label>
                                        <div className="d-flex flex-wrap gap-1">
                                            {symbols.map((item, index) => (
                                                <div key={index} className="position-relative">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary border-primary  btn-sm symbol-btn border al-border-radius-8"
                                                        onClick={() => insertSymbol(item.symbol, 'orderTransitTemplate')}  // Chỉnh sửa ở đây
                                                        title={item.description}
                                                        data-bs-toggle="tooltip"
                                                    >
                                                        {item.symbol}
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="mb-4 row">
                                    <div className="col-md-8">
                                        <label className="form-label fw-semibold">
                                            Feedback Request Template
                                        </label>
                                        <textarea
                                            className="form-control message-template"
                                            id="feedbackTemplate"  // Chỉnh sửa id tại đây
                                            rows={8}
                                            placeholder="Enter your personalized thank you message..."
                                            value={settings?.feedbackTemplate || `Hi {buyer_name}!
We hope your order has arrived safely! If you're happy with your purchase and our service, we'd be so grateful if you could leave us a 5-star review. Your positive feedback means a lot to us and helps us grow!

Once you've had a chance to try it, feel free to share your experience – we’d love to hear what you think!

Thank you so much for supporting {shop_name}!`}
                                            onChange={(e) => {
                                                onFormChange({ target: { name: "feedbackTemplate", value: e.target.value } });
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label fw-semibold">
                                            How many hours after deliveried
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control message-template mb-2"
                                            id="deliveriedTime"
                                            value={settings?.deliveriedTime || ''}
                                            onChange={(e) => {
                                                onFormChange({ target: { name: "deliveriedTime", value: e.target.value } });
                                            }}
                                            placeholder="Enter hours"
                                        />
                                        <label className="form-label fw-semibold">
                                            Status
                                        </label>
                                        <select
                                            className="form-control message-template"
                                            name="deliveriedStatus"
                                            value={settings?.deliveriedStatus || 'inactive'}
                                            onChange={(e) => {
                                                onFormChange({ target: { name: "deliveriedStatus", value: e.target.value } });
                                            }}
                                        >
                                            <option value="inactive">Inactive</option>
                                            <option value="active">Active</option>
                                        </select>
                                        <label className="form-label fw-semibold mt-2">
                                            AI generative
                                        </label>
                                        <select
                                            className="form-control message-template"
                                            name="deliveriedAIgen"
                                            value={settings?.deliveriedAIgen || 'inactive'}
                                            onChange={(e) => {
                                                onFormChange({ target: { name: "deliveriedAIgen", value: e.target.value } });
                                            }}
                                        >
                                            <option value="inactive">Inactive</option>
                                            <option value="active">Active</option>
                                        </select>
                                    </div>
                                    <div className="mt-3">
                                        <div className="d-flex flex-wrap gap-1">
                                            {symbols.map((item, index) => (
                                                <div key={index} className="position-relative">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary border-primary  btn-sm symbol-btn border al-border-radius-8"
                                                        onClick={() => insertSymbol(item.symbol, 'feedbackTemplate')}  // Chỉnh sửa ở đây
                                                        title={item.description}
                                                        data-bs-toggle="tooltip"
                                                    >
                                                        {item.symbol}
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={onToggle}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        onClick={handleSubmit}
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                    >
                        {t("Save")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = { updateSetting };

export default connect(mapStateToProps, mapDispatchToProps)(ModalSetting);
